import axios from 'axios'
import { getAppConfigSetting } from '../utils'
import { MARGINS_API } from './constants'

const getMarginsApi = () => `${getAppConfigSetting('apiUrl')}${MARGINS_API}`

const getMarginDetailsUrl = (accountNumber: string) => `${getMarginsApi()}/${accountNumber}`

export const getMarginsDetails = (accountNumber: string) =>
  axios.get(getMarginDetailsUrl(accountNumber), { withCredentials: true })
